(function () {
    'use strict';

    angular
        .module('app.widgets')
        .controller('UserLocationsController', UserLocationsController);

    /* @ngInject */
    function UserLocationsController(customerService, $uibModalInstance) {
        var vm = this;

        vm.$onInit = onInit;

        vm.title = 'Select Location';
        vm.tableConfig = customerService.getCustomerLocationTableState(onCustomerLocationSelected);
        vm.getCustomerLocations = customerService.getCustomerLocations;
        vm.customerLocations = [];
        vm.reset = reset;

        vm.isFilterCollapsed = false;

        function onInit() {
        }

        function reset() {
            $uibModalInstance.dismiss('cancel');
        }

        function onCustomerLocationSelected(location) {
            $uibModalInstance.close(location);
        }

    }
})();
